import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterializeModule } from 'angular2-materialize';
import { LaddaModule } from 'angular2-ladda';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { ZestCommonModule } from '../common/common.module';
import { NouisliderModule } from 'ng2-nouislider';

import { LoansDetailComponent } from '../loans/loans-detail/loans.detail-component';
import { LoanCardComponent } from '../loans/loans-card/loans.card-component';
import { UtilService } from '../loans/loans-card/utils.service';
import { LoanService } from '../loans/loans.service';
import { LoansComponent } from './loans.component';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    MaterializeModule,
    DeviceDetectorModule.forRoot(),
    LaddaModule.forRoot({
      style: 'contract',
      spinnerSize: 50,
      spinnerColor: '#1eba68',
      spinnerLines: 100,
    }),
    ZestCommonModule,
    NouisliderModule
  ],
  exports: [
    LoanCardComponent,
    LoansDetailComponent,
    LoansComponent
  ],
  declarations: [
    LoanCardComponent,
    LoansDetailComponent,
    LoansComponent
  ],
  providers: [
    LoanService,
    UtilService
  ]
})
export class LoansModule { }
